module.exports = __webpack_public_path__ + "img/pic_zb_d4.a3bd4357.png";